module.exports = __webpack_public_path__ + "static/media/bot.3aa5cb8f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bot.gif
// module id = 234
// module chunks = 0